module.exports = __webpack_public_path__ + "static/media/0023_IMG_LES_MURS_CHROMATIC_CH2_1019.929c8556.webp";